// @flow
import * as React from 'react';
import cx from 'classnames';

import cs from './styles.pcss';
import LeftArrow from './images/left-arrow.svg';
import RightArrow from './images/right-arrow.svg';

type Props = {
  direction: 'next' | 'prev',
  moveSlide: () => void,
};

export default function ArrowButton({
  direction,
  moveSlide,
}: Props): React.Node {
  return (
    <button
      type="button"
      onClick={moveSlide}
      className={cx(
        cs.btn,
        { [cs.next]: direction === 'next' },
        { [cs.prev]: direction === 'prev' }
      )}
    >
      {direction === 'next' && <RightArrow className={cs.icon} />}
      {direction === 'prev' && <LeftArrow className={cs.icon} />}
    </button>
  );
}
